const PHONE_PATTERN = /^(?:(?:\+?86[- ]?)?1[3-9]\d{9}|(?:0\d{2,3}[- ]?)?\d{7,8})$/;

export const normalizeText = (value) => {
  return typeof value === "string" ? value.trim() : value;
};

export const validatePhone = (rule, value, callback) => {
  const phone = normalizeText(value);

  if (!phone) {
    callback(new Error("电话号码不能为空"));
    return;
  }

  if (!PHONE_PATTERN.test(phone.replace(/\s+/g, ""))) {
    callback(new Error("请输入有效的电话号码"));
    return;
  }

  callback();
};

export const getRegionName = (list, value) => {
  const region = list.find((item) => item.value === value);
  return region ? region.name : "";
};

export const shouldShowSubmitError = (response) => {
  // code 为 400/500 时，请求拦截器提示后会返回 undefined。
  if (typeof response === "undefined") {
    return false;
  }

  if (!response) {
    return true;
  }

  // 非 2xx 响应有后端信息时，请求拦截器已经提示过。
  if (response.isAxiosError) {
    return !(
      response.response &&
      response.response.data &&
      response.response.data.message
    );
  }

  // 2xx 业务失败有 message 时，请求拦截器已经提示过。
  return !response.message;
};

export const isSubmitSuccess = (response) => {
  if (!response) {
    return false;
  }

  // 兼容旧接口的 result，以及当前接口的 success/code/data 结构。
  return Boolean(
    response.result ||
    response.data === true ||
    (response.success === true && Number(response.code) === 200)
  );
};



// WEBPACK FOOTER //
// ./src/util/form.js